<template>
  <div>
    <div class="row align-items-center">
      <div class="col-5">
        <label class="form-label">{{ $t(label) }}</label>
      </div>
      <div class="col-7">
        <div class="form-value">
          <div class="row">
            <div class="col">
              {{ title ? title : '-' }}
              <slot/>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PatientColInline",
  props: {
    title: {},
    label: String
  }
}
</script>

<style scoped lang="scss">
  .form-label {
    font-size: 14px;
    color: #AEBFD0;
    margin-bottom: 0;
  }
  .form-value {
    margin-bottom: 4px;
  }

  @media screen and (max-width: 768px) {
    .form-label {
      font-size: 11px;
    }
  }
</style>
